export const ADMIN_ROUTES = {
	ROOT: "/admin",
	VERSIONS: "/admin/versions",
	CHANGELOGS: "/admin/changelogs",
	CHANGELOG_NEW: "/admin/changelogs/new",
	CHANGELOG_EDIT: "/admin/changelogs/:id",
	BANNED_WORDS: "/admin/banned-words",
	MODERATION_EVENTS: "/admin/moderation-events",
	REPORTS: "/admin/reports",
	USERS: "/admin/users",
} as const;

export const buildChangelogEditPath = (id: string) => `/admin/changelogs/${id}`;
